import type { ComponentProps } from "react";
import { OpsConsoleScreen } from "../../features/ops";

/** FS-15 운영 콘솔(탭: 모니터 · 카탈로그 · 모드 · 설정 · 자산) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/ops */
export default function OpsConsolePage(props: ComponentProps<typeof OpsConsoleScreen>) {
  return <OpsConsoleScreen {...props} />;
}
